<div class="paginaPrincipal">
    <router-outlet></router-outlet>
</div>